// src/screens/customer/customerPannel/logout/Logout.jsx

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../context/auth/AuthContext";
import { LogOut, ArrowRight } from "lucide-react";
import "../../../../assets/css/customer/customerPannel/logout/Logout.css";

const Logout = () => {
  const navigate = useNavigate();
  const { logout, currentUser } = useAuth();

  useEffect(() => {
    logout();
    const timer = setTimeout(() => navigate("/"), 1000);
    return () => clearTimeout(timer);
  }, [logout, navigate]);

  const firstName =
    currentUser?.fullName?.split(" ")[0] || currentUser?.email || "";

  return (
    // Full-screen overlay — blocks everything behind it
    <div className="lo-overlay">
      {/* Decorative blobs */}
      <div className="lo-blob lo-blob-1" />
      <div className="lo-blob lo-blob-2" />
      <div className="lo-blob lo-blob-3" />

      {/* Popup card */}
      <div className="lo-card">
        {/* Icon */}
        <div className="lo-icon-wrap">
          <div className="lo-icon-ring" />
          <div className="lo-icon-circle">
            <LogOut size={32} strokeWidth={1.8} color="#5C6B47" />
          </div>
        </div>

        {/* Text */}
        <h1 className="lo-title">Logged Out!</h1>

        {firstName && (
          <p className="lo-bye">
            Goodbye, <strong>{firstName}</strong>! 👋
          </p>
        )}

        <p className="lo-msg">
          You've been successfully logged out.
          <br />
          Thank you for visiting <strong>AD Furniture House</strong>.
        </p>

        {/* Redirect bar */}
        <div className="lo-redirect">
          <div className="lo-spinner" />
          <span>Redirecting to home…</span>
        </div>

        {/* Progress bar */}
        <div className="lo-progress-track">
          <div className="lo-progress-bar" />
        </div>

        {/* Manual redirect button */}
        <button className="lo-home-btn" onClick={() => navigate("/")}>
          Go to Home <ArrowRight size={16} strokeWidth={2} />
        </button>
      </div>
    </div>
  );
};

export default Logout;
